import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

import type { Documentation, DocumentationType } from '../common/types/documentation';
import TextField from '../common/components/TextField';

type Props = {
  year: string;
  shortContactDocs: Documentation | undefined | null;
  updateItem: (item: Documentation, isNewItem: boolean, currentType: DocumentationType) => void;
};

function ShortContacts({ year, shortContactDocs, updateItem }: Props) {
  const shortContactInitialValue =
    shortContactDocs != null && shortContactDocs.numberOfShortContact != null
      ? shortContactDocs.numberOfShortContact
      : 0;

  const updateShortContacts = (newValue: number) => {
    if (shortContactDocs != null && shortContactDocs.numberOfShortContact != null) {
      updateItem({ ...shortContactDocs, numberOfShortContact: newValue }, false, 'shortContact');
    } else {
      updateItem(
        {
          id: uuidv4(),
          type: 'shortContact',
          date: year,
          numberOfShortContact: newValue,
        },
        true,
        'shortContact'
      );
    }
  };

  return (
    <Stack direction='row' alignItems='flex-end' sx={{ marginBottom: '32px' }}>
      <Typography mr={2} variant='body1'>
        Kurzkontakte:
      </Typography>
      <Stack direction='row'>
        <Button
          size='small'
          variant='outlined'
          sx={{}}
          aria-label='increase number of short contacts'
          onClick={async () => {
            const newValue = shortContactInitialValue === 0 ? 0 : shortContactInitialValue - 1;
            updateShortContacts(newValue);
          }}
        >
          <RemoveIcon fontSize='small' color='primary' />
        </Button>
        <TextField
          type='number'
          value={shortContactInitialValue}
          className='numberTextField'
          sx={{ padding: '0 5px', maxWidth: '80px' }}
          handleChange={(value) => {
            const valueAsNumber = Number(value);
            if (!isNaN(valueAsNumber)) {
              updateShortContacts(valueAsNumber);
            }
          }}
        />
        <Button
          size='small'
          variant='outlined'
          sx={{}}
          aria-label='decrease number of short contacts'
          onClick={async () => {
            const newValue = shortContactInitialValue + 1;
            updateShortContacts(newValue);
          }}
        >
          <AddIcon fontSize='small' color='primary' />
        </Button>
      </Stack>
    </Stack>
  );
}

export default ShortContacts;
